import { Instagram } from "lucide-react";
import { DiamondMark } from "./Brand";
import { SOCIALS } from "../data/products";

const TikTok = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 1 1-2.59-2.6c.27 0 .53.04.77.12V9.77a5.7 5.7 0 1 0 4.91 5.63V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.28 4.28 0 0 1-3.24-1.48z" /></svg>
);

const Social = ({ href, icon: Icon, label, handle, testid }) => (
  <a href={href} target="_blank" rel="noreferrer" data-testid={testid}
    className="group flex items-center justify-between gap-6 border-b border-white/10 py-5 hover:border-gold/60 transition-colors">
    <span className="flex items-center gap-4">
      <Icon className="w-5 h-5 text-violet-300 group-hover:text-gold transition-colors" />
      <span className="text-xs tracking-[0.3em] uppercase text-violet-200">{label}</span>
    </span>
    <span className="font-display text-xl sm:text-2xl text-white group-hover:text-gold transition-colors">{handle}</span>
  </a>
);

export const Footer = () => (
  <footer className="relative overflow-hidden pt-24 pb-10" data-testid="site-footer">
    <div className="absolute left-1/2 -translate-x-1/2 bottom-0 w-[50rem] h-[24rem] rounded-full bg-violet-700/20 blur-[140px]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-14">
      <div>
        <p className="text-[11px] tracking-[0.4em] uppercase text-gold mb-5">Stay plugged in</p>
        <p className="font-display text-3xl sm:text-4xl text-white leading-tight max-w-md">New suppliers, drops and flips. <span className="italic text-gold-purple">Follow the vault.</span></p>
      </div>
      <div>
        <Social href={SOCIALS.instagram.url} icon={Instagram} label="Instagram" handle={SOCIALS.instagram.handle} testid="footer-instagram-link" />
        <Social href={SOCIALS.tiktok.url} icon={TikTok} label="TikTok" handle={SOCIALS.tiktok.handle} testid="footer-tiktok-link" />
      </div>
    </div>
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 mt-20">
      <p className="font-display font-black text-[13vw] xl:text-[10.5rem] leading-[1.1] tracking-tight text-gold-purple select-none text-center" aria-hidden="true">SEEDOSELLZ</p>
      <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-violet-300/80 tracking-widest uppercase">
        <span className="flex items-center gap-2"><DiamondMark className="w-3 h-3" /> seedosellz.com · Luxury resale</span>
        <span>© {new Date().getFullYear()} SeedoSellz. Digital products, instant delivery.</span>
      </div>
    </div>
  </footer>
);
